import { Box, Header, addWithConfig } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';
import Picture from 'components/picture';

export const ImageContainer = Picture.withConfig<{ $windowHeight?: number }>(() => ({
  width: 'full',
  height: '216px',
  marginTop: '$16',
}));

export const NotAvailableContainer = Box.withConfig({
  marginLeft: '$4',
  marginRight: '$4',
  color: Styles.color.black,
});

export const SectionTitle = Header.withConfig({
  marginTop: '$8',
  textAlign: 'center',
  marginBottom: '$6',
});

export const StyledActionButtonLink = addWithConfig(ActionButton).withConfig({
  style: { height: 48 },
});
